import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo from "../components/Seo";
import { Reveal, Stagger, StaggerItem } from "../components/Reveal";
import { INDUSTRIES } from "../data/industries";
import { IMAGES } from "../data/site";

const Industries = () => (
  <>
    <Seo
      title="Industries We Serve | Utilities, EPCs, Solar & Traders — Universal Engineers"
      description="Universal Engineers supplies 3M cable accessories to transmission utilities, DISCOMs, EPC contractors, solar EPCs, railways, builders and electrical traders across India."
      path="/industries"
    />

    <section className="grain relative overflow-hidden bg-navy pb-20 pt-36 sm:pb-24 lg:pt-44" data-testid="industries-hero">
      <div className="bp-grid absolute inset-0" />
      <div className="relative z-10 mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <p className="flex items-center gap-3 font-mono text-[10px] uppercase tracking-[0.3em] text-slate-400 sm:text-xs">
            <span className="inline-block h-2 w-2 bg-safety" /> Industries We Serve
          </p>
          <h1 className="mt-6 max-w-3xl font-display text-4xl font-black uppercase leading-[1.05] tracking-tight text-white sm:text-5xl lg:text-6xl">
            Whoever joints the cable, we supply the certainty.
          </h1>
          <p className="mt-7 max-w-2xl text-base leading-relaxed text-slate-400 sm:text-lg">
            Seven sectors, one supply chain — genuine 3M material from
            Bhagirath Palace with documentation that survives tender audits.
          </p>
        </Reveal>
      </div>
    </section>

    <section className="py-16 sm:py-20" data-testid="industries-grid">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Stagger className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3" delay={0.03}>
          {INDUSTRIES.map((ind, i) => (
            <StaggerItem key={ind.title} className={i === 0 ? "sm:col-span-2 lg:col-span-1" : ""}>
              <div className="group flex h-full flex-col border border-slate-200 bg-white p-7 transition-all hover:-translate-y-1 hover:border-safety hover:shadow-xl" data-testid={`industry-card-${ind.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
                <div className="flex h-12 w-12 items-center justify-center border border-slate-200 transition-colors group-hover:border-safety group-hover:bg-safety-tint">
                  <ind.icon size={22} className="text-navy transition-colors group-hover:text-safety" strokeWidth={1.6} />
                </div>
                <h2 className="mt-5 font-display text-xl font-bold tracking-tight text-navy">{ind.title}</h2>
                <p className="mt-1.5 font-mono text-[10px] uppercase tracking-[0.16em] text-safety">{ind.clients}</p>
                <p className="mt-4 flex-1 text-sm leading-relaxed text-slate-600">{ind.need}</p>
              </div>
            </StaggerItem>
          ))}
          <StaggerItem>
            <div className="clip-notch relative flex h-full min-h-[220px] flex-col justify-end overflow-hidden bg-navy" data-testid="industries-banner-card">
              <img src={IMAGES.substation} alt="High voltage transmission towers — HT cable termination kits and heat shrink cable joints supplied across India" className="absolute inset-0 h-full w-full object-cover opacity-45" loading="lazy" />
              <div className="absolute inset-0 bg-gradient-to-t from-navy to-transparent" />
              <div className="relative z-10 p-7">
                <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-safety">Your sector not listed?</p>
                <p className="mt-2 font-display text-xl font-bold text-white">If it runs on cable, we stock for it.</p>
              </div>
            </div>
          </StaggerItem>
        </Stagger>
      </div>
    </section>

    <section className="grain relative overflow-hidden bg-navy py-20" data-testid="industries-cta">
      <div className="bp-grid absolute inset-0" />
      <div className="relative z-10 mx-auto max-w-3xl px-5 text-center sm:px-8">
        <Reveal>
          <h2 className="font-display text-3xl font-black uppercase tracking-tight text-white sm:text-4xl">
            Tell us your voltage. We'll send the quote.
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-slate-400">
            Response by next working day, first half — with stock position and
            documentation included.
          </p>
          <Link to="/enquiry" data-testid="industries-cta-button" className="group mt-8 inline-flex items-center gap-2.5 bg-safety px-8 py-4 font-display text-sm font-bold uppercase tracking-[0.12em] text-white transition-colors hover:bg-white hover:text-navy">
            Send Enquiry <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
          </Link>
        </Reveal>
      </div>
    </section>
  </>
);

export default Industries;
